<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置ICCID</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="iccid号">
                <el-input v-model="addForm.iccid" placeholder="请输入卡的iccid号"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china,} from "@/common/Base64MD5";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

        deviceXiaodouCode:'',
        iccid:'',

      },

      rules:{
        iccid:[
          { required: true, message: '请输入iccid号', trigger: 'blur' },
        ],

      }


    }
  },
  components: {

  },
  methods: {
    init(deviceXiaodouCode,iccid){
      this.$refs.addForm.resetFields();
      this.addForm.deviceXiaodouCode = deviceXiaodouCode;
      this.addForm.iccid = iccid;
    },
    closeSelf() {
      this.$emit("closeSet");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceXiaodou/SetICCID",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeSet");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }
}


</script>





<style lang="scss" scoped>

</style>
